import { render, staticRenderFns } from "./overdue-invoice-table.vue?vue&type=template&id=47aa0908&scoped=true"
import script from "./overdue-invoice-table.vue?vue&type=script&lang=js"
export * from "./overdue-invoice-table.vue?vue&type=script&lang=js"
import style0 from "./overdue-invoice-table.vue?vue&type=style&index=0&id=47aa0908&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aa0908",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47aa0908')) {
      api.createRecord('47aa0908', component.options)
    } else {
      api.reload('47aa0908', component.options)
    }
    module.hot.accept("./overdue-invoice-table.vue?vue&type=template&id=47aa0908&scoped=true", function () {
      api.rerender('47aa0908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/invoice/components/tables/overdue-invoice-table.vue"
export default component.exports